import { render, staticRenderFns } from "./CustomerDetail-customerQuotations.vue?vue&type=template&id=52de8f74&scoped=true"
import script from "./CustomerDetail-customerQuotations.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-customerQuotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de8f74",
  null
  
)

export default component.exports